// Post a verdict, then read the case back: the CASE is the outcome, not the HTTP answer (the rule useCases.decide
// already follows). Two answers that look like errors are recorded decisions: a rejection (403), and a case another
// device decided a moment earlier (422 "case already decided": the backbone locks the case, so the second tap waits
// and then reads it decided). 13 Oct 2026: approving a receipt send here after the iPad showed "case already
// decided" as an error and left the card up. Throws only when the case is still undecided afterwards.
import type {Case} from '@artemis-group/aiw-contracts';

export async function decideAndSettle<V extends {case_id:string}>(verdict:V,deps:{decide:(v:V)=>Promise<unknown>;read:(id:string)=>Promise<Case>}):Promise<{kase:Case;failure:Error|null}>{
 let failure:Error|null=null;
 try{await deps.decide(verdict);}catch(e){failure=e instanceof Error?e:new Error(String(e));}
 const kase=await deps.read(verdict.case_id);
 if(failure&&kase.status==='pending')throw failure;
 return {kase,failure};
}
